import { Column } from '@app/modules/table/classes/column.class';
import { CellDisplay } from '@app/modules/table/enums/cell-display.enum';
import { CustomReportQuery } from '@app/models/reporting/custom-report-query.model';

export class LastModifiedByColumn extends Column {
    title = 'reporting.custom-reports.reportTable.lastModifiedBy';
    type: CellDisplay = CellDisplay.string;

    getDisplayPropertyValue(object: CustomReportQuery): string | null {
        return object.lastUpdatedBy?.fullName ?? null;
    }
}
